import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, DBRadioButton, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpeechArticulationPhonology extends React.Component {

    render() {
        return (
            <div>

                <div className={styles.row}>
                    {this.props.flagged && <ObjectiveFlag className={styles.flag} mopno={this.props.mopno} flagged={this.props.flagged} flagText='Speech Articulation/Phonology' />}
                    <DBRadioButton
                        noteId={this.props.noteId}
                        selectedValue={'WNL'}
                        entityKeyColumn='OSNO'
                        entity='PTOBJECTIVESPEECH'
                        field='OSARTICULATIONSTATUS'
                        entityKeyValue={this.props.osno}
                        label='WNL'
                        className={styles.radio}
                    />


                    <div className={styles.label} />

                    <DBRadioButton
                        noteId={this.props.noteId}
                        selectedValue={'Delayed'}
                        entityKeyColumn='OSNO'
                        entity='PTOBJECTIVESPEECH'
                        field='OSARTICULATIONSTATUS'
                        entityKeyValue={this.props.osno}
                        label='Delayed'
                        className={styles.radio}
                    />

                    <div className={styles.label} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        selectedValue={'Impaired'}
                        entityKeyColumn='OSNO'
                        entity='PTOBJECTIVESPEECH'
                        field='OSARTICULATIONSTATUS'
                        entityKeyValue={this.props.osno}
                        label='Impaired'
                        className={styles.radio}
                    />
                    <div className={styles.label} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        selectedValue={'N/A due to lack of speech'}
                        entityKeyColumn='OSNO'
                        entity='PTOBJECTIVESPEECH'
                        field='OSARTICULATIONSTATUS'
                        entityKeyValue={this.props.osno}
                        label='N/A due to lack of speech'
                        className={styles.radio}
                    />
                </div>
                <div className={styles.row}>
                    <b>Comments</b>
                </div>

                <div className={styles.row}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSARTICULATIONCOMMENTS'
                        className={styles.textarea}
                    />

                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
        .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
    let flagged = false;
    if (state.entities.notes.PTOBJECTIVESPEECH[osno].OSARTICULATIONSTATUS !== undefined) {
        flagged = (state.entities.notes.PTOBJECTIVESPEECH[osno].OSARTICULATIONSTATUS !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSARTICULATIONSTATUS !== 'WNL')
            ? true : false
    }

    return {
        noteId: noteId,
        osno: osno,
        flagged: flagged,
    };
}

const connectedSpeechArticulationPhonology = connect(mapStateToProps)(SpeechArticulationPhonology);
export { connectedSpeechArticulationPhonology as SpeechArticulationPhonology };


